import { Model, attr } from 'redux-orm';
import {
  createAction,
  createAddConst,
  createDeleteConst,
  createRequestConst,
  createUpdateConst,
  createImportConst,
} from '../util';

export default class FspLoanAuthOption extends Model {
  static get modelName() {
    return 'FspLoanAuthOption';
  }

  static reducer({ type, data }, FspLoanAuthOption) {
    const asArray = (response) =>
      Array.isArray(response) ? response : response?.coreAuthOptions;

    const upsertOption = (option) => {
      FspLoanAuthOption.upsert({
        id: option.id,
        coreAuthOptionId: option.id,
        authOption: option.key,
        maxLength: option.maxLength,
        dataType: option.dataType,
        required: option.required,
        description: option.description,
        fspLoanAuthOption: option.fspLoanAuthOption,
        isEnabled: !!option.fspLoanAuthOption,
        createdAt: option.fspLoanAuthOption?.createdAt,
        updatedAt: option.fspLoanAuthOption?.updatedAt,
      });
    };

    const findByCoreId = (coreAuthOptionId) =>
      FspLoanAuthOption.all()
        .toModelArray()
        .find((opt) => opt.coreAuthOptionId === coreAuthOptionId);

    switch (type) {
      case LOAD.ACTION:
        FspLoanAuthOption.all().delete();
        break;

      case LOAD.SUCCESS: {
        const options = asArray(data.response);
        if (options && Array.isArray(options)) options.forEach(upsertOption);
        break;
      }

      case LOAD.FAILURE: {
        FspLoanAuthOption.all().delete();
        break;
      }

      case CREATE.SUCCESS: {
        const createdOption = data.response?.coreAuthOption || data.response;
        if (createdOption && createdOption.id) {
          const coreAuthOptionId = createdOption.id;
          const existingOption = findByCoreId(coreAuthOptionId);

          if (existingOption) {
            existingOption.update({
              fspLoanAuthOption: createdOption.fspLoanAuthOption,
              isEnabled: true,
              createdAt:
                createdOption.fspLoanAuthOption?.createdAt ||
                existingOption.createdAt,
              updatedAt: createdOption.fspLoanAuthOption?.updatedAt,
            });
          }
        }
        break;
      }

      case REMOVE.SUCCESS: {
        const removedOption = data.response?.coreAuthOption || data.response;
        if (removedOption && removedOption.id) {
          const coreAuthOptionId = removedOption.id;
          const existingOption = findByCoreId(coreAuthOptionId);

          if (existingOption) {
            existingOption.update({
              fspLoanAuthOption: null,
              isEnabled: false,
              updatedAt:
                removedOption.fspLoanAuthOption?.updatedAt ||
                existingOption.updatedAt,
            });
          }
        }
        break;
      }

      case UPDATE.SUCCESS: {
        const updatedOption = data.response?.coreAuthOption || data.response;
        if (updatedOption && updatedOption.id) {
          const coreAuthOptionId = updatedOption.id;
          const existingOption = findByCoreId(coreAuthOptionId);

          if (existingOption) {
            existingOption.update({
              fspLoanAuthOption: updatedOption.fspLoanAuthOption,
              updatedAt:
                updatedOption.fspLoanAuthOption?.updatedAt ||
                existingOption.updatedAt,
            });
          }
        }
        break;
      }

      case IMPORT.SUCCESS: {
        const options = asArray(data.response);
        if (options && Array.isArray(options)) {
          // Clear existing options and reload all
          FspLoanAuthOption.all().delete();
          options.forEach(upsertOption);
        }
        break;
      }

      default:
        break;
    }
  }

  static get fields() {
    return {
      coreAuthOptionId: attr(),
      authOption: attr(),
      maxLength: attr(),
      dataType: attr(),
      required: attr(),
      description: attr(),
      fspLoanAuthOption: attr(),
      isEnabled: attr(),
      createdAt: attr(),
      updatedAt: attr(),
    };
  }
}

const name = FspLoanAuthOption.modelName;

export const CREATE = createAddConst(name);
export const LOAD = createRequestConst(name);
export const REMOVE = createDeleteConst(name);
export const UPDATE = createUpdateConst(name);
export const IMPORT = createImportConst(name);

export const create = createAction(CREATE);
export const load = createAction(LOAD);
export const remove = createAction(REMOVE);
export const update = createAction(UPDATE);
export const importLoanAuthOptions = createAction(IMPORT);
